import apiClient from './client';

export const fetchReckoningEligibility = async () => {
  const response = await apiClient.get('/api/reckoning/eligibility');
  return response.data;
};

export const launchReckoning = async () => {
  const response = await apiClient.post('/api/reckoning/launch');
  return response.data;
};

export const fetchReckoningState = async (reckoningId) => {
  const response = await apiClient.get(`/api/reckoning/${reckoningId}/state`);
  return response.data;
};

export const forfeitReckoning = async (reckoningId) => {
  const response = await apiClient.post(`/api/reckoning/${reckoningId}/forfeit`);
  return response.data;
};

export const initReckoningFinalBoss = async (reckoningId) => {
  const response = await apiClient.post(
    `/api/combat/v2/reckoning/${reckoningId}/final/init`,
    null,
    { timeout: 180000 }
  );
  return response.data;
};
